
//TODO : 
// date format
// refresh

import React from 'react';
import Moment from 'react-moment';
import { CardMedium } from '../../widgets/Cards';
//import Modal from '../../widgets/Modal';
//import Confirm from '../../widgets/Confirm';
import {connect} from 'react-redux';
//import { Form, Field} from 'react-final-form';

import { fetchRequestPaths, fetchRequestPath, editRequestPath, newRequestPath, deleteRequestPath} from '../../../actions';

class RequestPath extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            showDelete : false,
            newForm : true,
            record : null,
        };
    };

    //Initial Rendering
    componentDidMount() {
        this.props.fetchRequestPaths(this.props.patient._id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.patient._id !== prevProps.patient._id) {
                this.props.fetchRequestPaths(this.props.patient._id)
        }   
    }

        // sorting data by date
        compareDate(a, b) {

            var key1 = a.requestdate;
            var key2 = b.requestdate;
        
            if (key1 > key2) {
                return -1;
            } else if (key1 === key2) {
                return 0;
            } else {
                return 1;
            }
        }
 
    renderRequestPathList() {

        var list = this.props.requestpaths;
        var sortedList = list.sort(this.compareDate);

        return sortedList.map(requestpath =>  {
         
          
                return (
                        <tr key={requestpath._id}>
                            <td><Moment format='DD MMM YYYY'>{requestpath.requestdate}</Moment></td>
                            <td>{requestpath.providername}</td>
                            <td>{requestpath.test}</td>
                            <td>{requestpath.clinical}</td>
                            <td>{requestpath.provider}</td>
                            <td>{requestpath.privacy}</td>
                        </tr>
                        )
        })
    }

    render() {
        return (
            <CardMedium title='Pathology Requests' >
                <table>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Path Provider</th>
                            <th>Tests/Imaging</th>
                            <th>Notes</th>
                            <th>Provider</th>
                            <th>Privacy</th>
                        </tr>
                    </thead>
                    <tbody> 
                        {this.renderRequestPathList()}
                    </tbody> 
                </table>
            </CardMedium>
        )
    }

}

const mapStateToProps = (state) => {
    return { 
        patient : state.selectedPatient,
        requestpaths : Object.values(state.requestpaths),
        userId : state.auth.userId,
        selectedRequestPath : state.selectedRequestPath
    }
}

export default connect(mapStateToProps, {fetchRequestPaths, fetchRequestPath, editRequestPath, newRequestPath, deleteRequestPath})(RequestPath);










    








